define('score_bootstrap/Models/Search/PromoTile',["jquery", "knockout"], function ($, ko) {
    "use strict";

    function PromoTile(index, element) {
        if (isNaN(index) || index < 1) {
            throw new Error("PromoTile index must be positive integer");
        }

        if (!element) {
            throw new Error("PromoTile index is required");
        }

        Object.defineProperties(this,
        {
            index:   { value: index },
            tileHtml: { value: element.outerHTML }
        });
    }

    PromoTile.fromElement = function fromElement(element) {
        var index = $(element).attr("data-grid-position");
        index = parseInt(index, 10);
        return new PromoTile(index, element);
    };

    PromoTile.sort = function sort(a, b) {
        return a.index - b.index;
    };

    return PromoTile;
});
